import React from 'react';
import '../Colors.css';

const User = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslPinkLight' d="M255.96 261.061c0 144.793 117.215 264.15 258.554 264.15h3.45c141.343 0 258.554-119.357 258.554-264.15s-117.211-262.008-258.55-262.008c-144.793 0-262.008 117.215-262.008 262.008z"/>
      <path className='HslGreenLight' d="M888.376 656.93c-28.821-89.662-79.128-120.882-159.189-120.882h-64.042c0 0-63.425 69.382-152.169 69.382-90.984 0-152.039-69.382-152.039-69.382h-64.046c-80.060 0-128.829 31.219-160.85 120.882 0 0-71.636 251.918-71.372 284.579 0.177 21.913 14.894 39.394 34.694 45.955 20.613 9.291 64.985 17.68 125.372 23.976l27.321-175.557h25.988v180.231c68.638 5.119 150.724 8.103 238.649 8.103 87.755 0 169.564-2.977 238.201-8.081v-180.253h26.415l28.355 175.315c60.419-6.409 104.423-14.829 124.071-24.251 16.621-6.141 27.553-20.797 27.553-45.409-0.004-32.661-72.911-284.607-72.911-284.607z"/>
    </svg>
  );
};

export default User;